// ApproachSection.js
import React, { useState } from 'react';
import './ApproachSection.css';

const ApproachSection = () => {
  const [activeTab, setActiveTab] = useState('propunem');

  return (
    <section id="approach" className="approach-section">
      <h2>Abordarea noastră</h2>
      <div className="tabs">
        <button
          className={activeTab === 'propunem' ? 'active' : ''}
          onClick={() => setActiveTab('propunem')}
        >
          CE NE PROPUNEM?
        </button>
        <button
          className={activeTab === 'oferim' ? 'active' : ''}
          onClick={() => setActiveTab('oferim')}
        >
          CE VĂ OFERIM?
        </button>
        <button
          className={activeTab === 'functionam' ? 'active' : ''}
          onClick={() => setActiveTab('functionam')}
        >
          CUM FUNCŢIONĂM?
        </button>
      </div>

      <div className="tab-content">
        {activeTab === 'propunem' && (
          <div className="tab-panel">
            <h4>Grădinița îşi propune să ofere un proces educațional performant, atractiv și stimulativ, urmărind:</h4>
            <ul>
              <li>
                Dezvoltarea liberă, integrală și armonioasă a personalității copilului și formarea autonomă și creativă a acestuia;
              </li>
              <li>
                Dezvoltarea capacității de a interacționa cu alți copii, cu adulții și cu mediul pentru a dobândi cunoștinţe, priceperi, atitudini şi conduite noi;
              </li>
              <li>
                Încurajarea explorărilor, exercițiilor, încercărilor și experimentărilor, ca experiențe autonome de învățare;
              </li>
              <li>
                Descoperirea de către fiecare copil a propriei identități, a autonomiei și dezvoltarea unei imagini de sine pozitive;
              </li>
              <li>
                Sprijinirea copilului în achiziționarea de cunoștințe, capacități, deprinderi şi atitudini necesare la intrarea în școală și pe tot parcursul vieții.
              </li>
            </ul>
          </div>
        )}

        {activeTab === 'oferim' && (
          <div className="tab-panel">
            <h4>Activități curriculare</h4>
            <ul>
              <li>Jocuri și activități liber alese</li>
              <li>Activități pe domenii experiențiale</li>
              <li>Domeniul ştiinţă</li>
              <li>Domeniul limbă și comunicare</li>
              <li>Domeniul estetic și creativ</li>
              <li>Domeniul om și societate</li>
              <li>Domeniul psihomotric</li>
            </ul>
            <h4>Activități opționale</h4>
            <ul>
              <li>Limba engleză</li>
              <li>Dans modern/gimnastică</li>
              <li>Brain gym</li>
              <li>Pictură</li>
              <li>Cooking</li>
              <li>Pian</li>
              <li>Balet</li>
              <li>Karate</li>
            </ul>
            <h4>Activități extracurriculare</h4>
            <ul>
              <li>Plimbări, excursii, tabere</li>
              <li>Vizite la muzee şi alte obiective culturale</li>
              <li>Serbări, petreceri cu ocazia aniversărilor copiilor</li>
              <li>Târguri, expoziții cu diferite ocazii</li>
              <li>Consiliere psihologică/logopedică</li>
            </ul>
          </div>
        )}

        {activeTab === 'functionam' && (
          <div className="tab-panel">
            <h4>Grădinița cu Program Prelungit „Margot”</h4>
            <ul>
              <li>53 locuri</li>
              <li>2 grupe mici (2/3-4 ani)</li>
              <li>1 grupă mijlocie (4-5 ani)</li>
              <li>1 grupă mare (5-6 ani)</li>
            </ul>
            <h4>Resursa umană</h4>
            <p><strong>Personal didactic</strong></p>
            <ul>
              <li>6 profesori pentru învățământ preșcolar</li>
              <li>1 psiholog/logoped</li>
              <li>3 profesori specializați pentru opțional</li>
            </ul>
            <p><strong>Personal nedidactic</strong></p>
            <ul>
              <li>2 îngrijitoare</li>
              <li>1 asistentă medicală</li>
              <li>1 medic generalist</li>
            </ul>
          </div>
        )}
      </div>
    </section>
  );
};

export default ApproachSection;
